function drawImage(
  imageSrc,
  maxImageHeight,
  canvasWidth,
  context,
  currentHeight,
) {
  return new Promise((resolve) => {
    const image = new Image();
    image.onload = () => {
      let imageHeight = maxImageHeight;
      let imageWidth = (image.width * imageHeight) / image.height;
      if (imageWidth > canvasWidth) {
        imageWidth = canvasWidth;
        imageHeight = (image.height * imageWidth) / image.width;
      }
      const xPos = canvasWidth / 2 - imageWidth / 2;
      context.drawImage(image, xPos, currentHeight, imageWidth, imageHeight);
      resolve(imageHeight);
    };
    image.crossOrigin = 'anonymous';
    image.src = imageSrc;
  });
}

function getMargin(context, line, maxWidth) {
  const lineWidth = context.measureText(line).width;
  return 8 + (maxWidth - lineWidth) / 2;
}

function wrapText(context, text, marginTop, maxWidth, elem) {
  context.font = elem.font;
  const words = text.split(' ');
  let line = '';
  let xPosition = 0;
  let currentHeight = marginTop;
  words.forEach((word) => {
    const testLine = line + word + ' ';
    const testWidth = context.measureText(testLine).width;
    if (testWidth > maxWidth) {
      xPosition = getMargin(context, line.trim(), maxWidth);
      context.fillText(line.trim(), xPosition, currentHeight);
      line = word + ' ';
      currentHeight += elem.lineHeight;
    } else {
      line = testLine;
    }
  });
  xPosition = getMargin(context, line.trim(), maxWidth);
  context.fillText(line.trim(), xPosition, currentHeight);
  return currentHeight + elem.lineHeight;
}

function calculateTextHeight(context, text, maxWidth, elem) {
  context.font = elem.font;
  const words = text.split(' ');
  let line = '';
  let height = 0;
  words.forEach((word) => {
    const testLine = line + word + ' ';
    const testWidth = context.measureText(testLine).width;
    if (testWidth > maxWidth) {
      height += elem.lineHeight;
      line = word + ' ';
    } else {
      line = testLine;
    }
  });
  height += elem.lineHeight;
  return height;
}

function drawText(elem, context, currentHeight, textContent) {
  let updatedHeight = currentHeight;
  if (textContent && textContent.length > 0) {
    updatedHeight = wrapText(context, textContent, currentHeight, 300, elem);
  }
  return updatedHeight;
}

async function printTicket(
  canvas,
  ticketData,
  ticketSettings,
  firmStyles,
  officeSettings,
  officeAddress,
  phone,
  currentLanguageTag,
  ticketDate,
) {
  const possibleElements = [
    {
      name: 'ticket-id',
      font: '500 42px Inter, sans-serif',
      lineHeight: 51,
      text: `${ticketData.prefix}${ticketData.number}`,
    },
    {
      name: 'ticket-service',
      font: '500 16px Inter, sans-serif',
      lineHeight: 22,
      text:
        ticketSettings.use_service_name &&
        ticketData.service.name[currentLanguageTag]
          ? ticketData.service.name[currentLanguageTag]
          : '',
    },
    {
      name: 'ticket-name-surname',
      font: '500 16px Inter, sans-serif',
      lineHeight: 22,
      text:
        ticketData.name && ticketData.surname
          ? `${ticketData.name} ${ticketData.surname}`
          : '',
    },
    {
      name: 'ticket-service-desc',
      font: '12px Inter, sans-serif',
      lineHeight: 17,
      text:
        ticketSettings.use_service_definition &&
        ticketData.service.print_text[currentLanguageTag]
          ? ticketData.service.print_text[currentLanguageTag]
          : '',
    },
    {
      name: 'ticket-office-info',
      font: '12px Inter, sans-serif',
      lineHeight: 17,
      text:
        ticketSettings.use_info_about_office &&
        officeSettings.registrator_text[currentLanguageTag]
          ? officeSettings.registrator_text[currentLanguageTag]
          : '',
    },
    {
      name: 'ticket-slogan',
      font: '500 16px Inter, sans-serif',
      lineHeight: 22,
      text:
        ticketSettings.use_slogan && firmStyles.slogan ? firmStyles.slogan : '',
    },
    {
      name: 'ticket-getting-time',
      font: '12px Inter, sans-serif',
      lineHeight: 17,
      text: ticketSettings.use_date_of_ticket_getting
        ? `Выдано: ${ticketDate}`
        : '',
    },
    {
      name: 'ticket-address',
      font: '12px Inter, sans-serif',
      lineHeight: 17,
      text:
        ticketSettings.use_address_of_office && officeAddress
          ? officeAddress
          : '',
    },
    {
      name: 'ticket-phone',
      font: '500 16px Inter, sans-serif',
      lineHeight: 22,
      text:
        ticketSettings.use_telephone_of_office && phone ? `📞 ${phone}` : '',
    },
  ];

  const context = canvas.getContext('2d');

  canvas.width = 320; // Ширина остаётся фиксированной, как для принтера

  // Рассчет общей высоты для динамического canvas
  let totalHeight = 0;
  let logoHeight = 0;
  if (
    ticketSettings.use_company_logo &&
    ticketSettings.ticket_logo &&
    ticketSettings.ticket_logo.file_url
  ) {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.src = ticketSettings.ticket_logo.file_url;
    await new Promise((resolve) => {
      image.onload = resolve;
    });
    let imgH = 80;
    let imgW = (image.width * imgH) / image.height;
    if (imgW > canvas.width) {
      imgW = canvas.width;
      imgH = (image.height * imgW) / image.width;
    }
    logoHeight = imgH;
    totalHeight += logoHeight + 50; // Отступ после логотипа 50px
  }

  possibleElements.forEach((elem) => {
    if (elem.text && elem.text.length > 0) {
      const textH = calculateTextHeight(context, elem.text, 300, elem);
      totalHeight += textH;
    }
    if (
      (elem.name === 'ticket-office-info' && elem.text) ||
      (elem.name === 'ticket-slogan' && elem.text) ||
      (elem.name === 'ticket-phone' && ticketSettings.use_telephone_of_office)
    ) {
      totalHeight += 5 + 30; // Твои значения для линий: нижний 5, верхний 30
    }
    // Добавляем 5px между строками в группе контактов (после getting-time и address, если они есть)
    if (
      ((elem.name === 'ticket-getting-time' && elem.text) ||
        (elem.name === 'ticket-address' && elem.text)) &&
      elem.text.length > 0
    ) {
      totalHeight += 5;
    }
  });

  const topMargin = 20; // Отступ сверху
  const bottomMargin = 20; // Отступ снизу
  canvas.height = totalHeight + topMargin + bottomMargin; // Динамическая высота

  context.clearRect(0, 0, canvas.width, canvas.height);

  // Восстановлен поворот для правильной печати на принтере
  context.translate(canvas.width, canvas.height);
  context.rotate(Math.PI);

  // Начальная позиция без центрирования, с отступом сверху
  let currentHeight = topMargin;

  // Настройка пунктирных линий
  context.strokeStyle = 'black';
  context.lineWidth = 1;
  context.setLineDash([2, 2]);

  // Отрисовка логотипа
  if (
    ticketSettings.use_company_logo &&
    ticketSettings.ticket_logo &&
    ticketSettings.ticket_logo.file_url
  ) {
    const drawnLogoHeight = await drawImage(
      ticketSettings.ticket_logo.file_url,
      80,
      canvas.width,
      context,
      currentHeight,
    );
    currentHeight += drawnLogoHeight + 50;
  }

  // Отрисовка элементов
  possibleElements.forEach((elem) => {
    if (elem.text && elem.text.length > 0) {
      currentHeight = drawText(elem, context, currentHeight, elem.text);
    }
    if (
      (elem.name === 'ticket-office-info' && elem.text) ||
      (elem.name === 'ticket-slogan' && elem.text) ||
      (elem.name === 'ticket-phone' && ticketSettings.use_telephone_of_office)
    ) {
      currentHeight += 5; // Нижний отступ перед линией
      context.beginPath();
      context.moveTo(10, currentHeight);
      context.lineTo(canvas.width - 10, currentHeight);
      context.stroke();
      currentHeight += 30; // Верхний отступ после линии
    }
    // Добавляем 5px между строками в группе контактов (после getting-time и address)
    if (
      (elem.name === 'ticket-getting-time' || elem.name === 'ticket-address') &&
      elem.text &&
      elem.text.length > 0
    ) {
      currentHeight += 5;
    }
  });

  context.setLineDash([]);

  const dataUrl = canvas.toDataURL().split(',');
  return dataUrl[1];
}

export { printTicket, wrapText };
